import { BaseType } from '../../base/base-type';
import { ContributionTypeEnum } from '../../../features/new-contribution/enums/contribution-type.enum';

export class MemberContributionType extends BaseType {
  public declare id: ContributionTypeEnum;
}
